import React from 'react';
import {
  PhoneIcon, EmailIcon, WhatsAppIcon, LocationIcon,
  CalendarIcon, BriefcaseIcon, StarIcon, HomeIcon,
  CheckIcon, TrophyIcon, BuildingIcon
} from '../components/Icons/Icons';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import PropertyCard from '../components/PropertyCard/PropertyCard';
import './AgentProfile.css';

function AgentProfile() {
  const agent = {
    name: 'Ahmed Khan',
    agency: 'Premium Properties Ltd.',
    photo: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400',
    verified: true,
    rating: 4.8,
    reviews: 156,
    properties: 87,
    experience: 12,
    phone: '+92 300 1234567',
    email: 'ahmed.khan@premiumproperties.pk',
    languages: ['English', 'Urdu', 'Sindhi'],
    specializations: ['Residential', 'Commercial', 'Luxury Homes'],
    bio: `Ahmed Khan is a seasoned real estate professional with over 12 years of experience in the Pakistani property market. Specializing in luxury residential and commercial properties across Karachi, Ahmed has successfully closed over 200 deals and helped countless families find their dream homes.

His deep understanding of the local market, combined with exceptional negotiation skills and client-focused approach, has earned him a reputation as one of the most trusted agents in the industry. Ahmed believes in building long-term relationships with his clients and is committed to providing transparent, honest, and professional service.`,
    achievements: [
      'Top Agent 2023',
      '200+ Successful Deals',
      'Certified Real Estate Professional',
      'Customer Choice Award Winner'
    ],
    location: 'Karachi, Pakistan',
    joinedDate: 'January 2012'
  };

  const agentListings = [
    {
      id: 1,
      images: ['https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800'],
      price: 'PKR 1.5 Crore',
      pricePerSqft: 'PKR 30,000/sq ft',
      title: 'Luxury 5 Bedroom Villa with Swimming Pool',
      location: 'DHA Phase 6, Karachi',
      beds: 5,
      baths: 6,
      area: '500 sq yd',
      type: 'House',
      postedDate: '2 days ago',
      featured: true,
      verified: true
    },
    {
      id: 2,
      images: ['https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800'],
      price: 'PKR 1.2 Crore',
      pricePerSqft: 'PKR 28,000/sq ft',
      title: 'Modern 4 Bedroom House',
      location: 'DHA Phase 5, Karachi',
      beds: 4,
      baths: 5,
      area: '400 sq yd',
      type: 'House',
      postedDate: '1 week ago',
      featured: false,
      verified: true
    },
    {
      id: 3,
      images: ['https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800'],
      price: 'PKR 1.8 Crore',
      pricePerSqft: 'PKR 32,000/sq ft',
      title: 'Spacious Villa with Garden',
      location: 'DHA Phase 7, Karachi',
      beds: 6,
      baths: 7,
      area: '600 sq yd',
      type: 'House',
      postedDate: '3 days ago',
      featured: true,
      verified: true
    },
    {
      id: 4,
      images: ['https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800'],
      price: 'PKR 85 Lac',
      pricePerSqft: 'PKR 8,500/sq ft',
      title: 'Premium 3 Bedroom Apartment',
      location: 'Clifton Block 4, Karachi',
      beds: 3,
      baths: 3,
      area: '2000 sq ft',
      type: 'Apartment',
      postedDate: '5 days ago',
      featured: false,
      verified: true
    },
    {
      id: 5,
      images: ['https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800'],
      price: 'PKR 2.5 Crore',
      pricePerSqft: 'PKR 35,000/sq ft',
      title: 'Ultra Luxury Penthouse',
      location: 'DHA Phase 8, Karachi',
      beds: 4,
      baths: 5,
      area: '700 sq yd',
      type: 'Penthouse',
      postedDate: '1 day ago',
      featured: true,
      verified: true
    },
    {
      id: 6,
      images: ['https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800'],
      price: 'PKR 95 Lac',
      pricePerSqft: 'PKR 9,000/sq ft',
      title: 'Elegant 2 Bedroom Flat',
      location: 'Gulshan-e-Iqbal, Karachi',
      beds: 2,
      baths: 2,
      area: '1500 sq ft',
      type: 'Apartment',
      postedDate: '4 days ago',
      featured: false,
      verified: false
    }
  ];

  const handleContact = (type) => {
    console.log(`Contact agent via ${type}`);
  };

  return (
    <div className="agent-profile-page">
      <Header />

      <div className="agent-profile-container">
        <div className="agent-profile-header">
          <div className="agent-profile-hero">
            <div className="agent-hero-content">
              <div className="agent-photo-large">
                {agent.photo ? (
                  <img src={agent.photo} alt={agent.name} />
                ) : (
                  <div className="agent-photo-placeholder">
                    {agent.name.charAt(0)}
                  </div>
                )}
                {agent.verified && (
                  <div className="verified-badge">
                    <CheckIcon size={14} color="white" />
                  </div>
                )}
              </div>

              <div className="agent-hero-info">
                <h1 className="agent-name-large">{agent.name}</h1>

                {agent.agency && (
                  <p className="agent-agency-name">
                    <BuildingIcon size={18} color="var(--color-text-secondary)" />
                    {agent.agency}
                  </p>
                )}

                <div className="agent-meta-info">
                  <div className="meta-item">
                    <LocationIcon size={16} color="var(--color-text-secondary)" />
                    <span>{agent.location}</span>
                  </div>
                  <div className="meta-item">
                    <CalendarIcon size={16} color="var(--color-text-secondary)" />
                    <span>Joined {agent.joinedDate}</span>
                  </div>
                  <div className="meta-item">
                    <BriefcaseIcon size={16} color="var(--color-text-secondary)" />
                    <span>{agent.experience}+ years experience</span>
                  </div>
                </div>

                {agent.rating && (
                  <div className="agent-rating-large">
                    <div className="rating-stars-large">
                      {[...Array(5)].map((_, index) => (
                        <StarIcon
                          key={index}
                          size={20}
                          color="#f59e0b"
                          filled={index < Math.floor(agent.rating)}
                        />
                      ))}
                    </div>
                    <span className="rating-text-large">
                      {agent.rating} ({agent.reviews} reviews)
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="agent-contact-card">
              <h3 className="contact-title">Contact {agent.name}</h3>

              <div className="contact-buttons">
                <button className="contact-btn btn-primary" onClick={() => handleContact('call')}>
                  <PhoneIcon size={18} />
                  <span>Call Now</span>
                </button>

                <button className="contact-btn btn-secondary" onClick={() => handleContact('email')}>
                  <EmailIcon size={18} />
                  <span>Email</span>
                </button>

                <button className="contact-btn btn-whatsapp" onClick={() => handleContact('whatsapp')}>
                  <WhatsAppIcon size={18} />
                  <span>WhatsApp</span>
                </button>
              </div>

              <div className="contact-info">
                <div className="contact-info-item">
                  <PhoneIcon size={16} color="var(--color-text-secondary)" />
                  <span className="info-text">{agent.phone}</span>
                </div>
                <div className="contact-info-item">
                  <EmailIcon size={16} color="var(--color-text-secondary)" />
                  <span className="info-text">{agent.email}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="agent-profile-content">
          <div className="agent-stats-grid">
            <div className="stat-card">
              <div className="stat-icon-large">
                <HomeIcon size={48} color="var(--color-primary)" />
              </div>
              <div className="stat-value-large">{agent.properties}</div>
              <div className="stat-label-large">Active Listings</div>
            </div>

            <div className="stat-card">
              <div className="stat-icon-large">
                <CalendarIcon size={48} color="var(--color-primary)" />
              </div>
              <div className="stat-value-large">{agent.experience}+</div>
              <div className="stat-label-large">Years Experience</div>
            </div>

            <div className="stat-card">
              <div className="stat-icon-large">
                <StarIcon size={48} color="var(--color-primary)" filled={true} />
              </div>
              <div className="stat-value-large">{agent.rating}</div>
              <div className="stat-label-large">Average Rating</div>
            </div>

            <div className="stat-card">
              <div className="stat-icon-large">
                <CheckIcon size={48} color="var(--color-primary)" />
              </div>
              <div className="stat-value-large">{agent.reviews}</div>
              <div className="stat-label-large">Client Reviews</div>
            </div>
          </div>

          <div className="agent-about-section">
            <h2 className="section-title">About {agent.name}</h2>
            <div className="about-content">
              <p className="bio-text">{agent.bio}</p>

              <div className="agent-details-grid">
                <div className="detail-group">
                  <h3 className="detail-title">Languages</h3>
                  <div className="detail-tags">
                    {agent.languages.map((lang, index) => (
                      <span key={index} className="detail-tag">{lang}</span>
                    ))}
                  </div>
                </div>

                <div className="detail-group">
                  <h3 className="detail-title">Specializations</h3>
                  <div className="detail-tags">
                    {agent.specializations.map((spec, index) => (
                      <span key={index} className="detail-tag">{spec}</span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="achievements-section">
                <h3 className="detail-title">Achievements</h3>
                <div className="achievements-grid">
                  {agent.achievements.map((achievement, index) => (
                    <div key={index} className="achievement-item">
                      <TrophyIcon size={24} color="#f59e0b" />
                      <span className="achievement-text">{achievement}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="agent-listings-section">
            <div className="section-header">
              <h2 className="section-title">Properties by {agent.name}</h2>
              <p className="section-subtitle">{agentListings.length} active listings</p>
            </div>

            <div className="properties-grid">
              {agentListings.map(property => (
                <PropertyCard key={property.id} property={property} />
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AgentProfile;
